import { Check } from 'lucide-react';
import { formatDate } from '@/components/booking/bookingData';
import { bt, vehClass } from '@/i18n/bookingI18n';

export function BookingConfirmation({ form, bookingRef, getPrice, onReset, lang = 'en' }) {
  return (
    <div data-testid="book-chauffeur-page" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="min-h-[80vh] bg-[#FAFAFA] flex items-center justify-center px-4 py-16">
        <div data-testid="booking-confirmation" className="max-w-lg w-full text-center">
          <div className="w-20 h-20 rounded-full bg-[#EE5A01] flex items-center justify-center mx-auto mb-6">
            <Check className="w-10 h-10 text-white" />
          </div>
          <h1 className="font-heading font-black text-3xl sm:text-4xl text-[#121212] uppercase tracking-tight mb-3">
            {bt(lang, 'bookingReceived')}
          </h1>
          <p className="font-body text-[#666666] mb-8">
            {bt(lang, 'thankYouChauffeur', form.name)}
          </p>
          <div className="bg-white border border-black/10 rounded-2xl p-6 text-left space-y-3 mb-8 shadow-sm">
            <div className="flex justify-between">
              <span className="font-body text-xs text-[#666666] uppercase">{bt(lang, 'reference')}</span>
              <span className="font-mono text-sm text-[#EE5A01]">{bookingRef}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-body text-xs text-[#666666] uppercase">{bt(lang, 'sumVehicle')}</span>
              <span className="font-heading text-sm text-[#121212]">{vehClass(lang, form.vehicle)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-body text-xs text-[#666666] uppercase">{bt(lang, 'sumDate')}</span>
              <span className="font-heading text-sm text-[#121212]">{formatDate(form.date, lang)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-body text-xs text-[#666666] uppercase">{bt(lang, 'sumDuration')}</span>
              <span className="font-heading text-sm text-[#121212]">{form.duration === '4h' ? bt(lang, 'half4hFull') : bt(lang, 'full8hFull')}</span>
            </div>
            <div className="border-t border-black/10 pt-3 flex justify-between">
              <span className="font-heading text-sm text-[#121212] uppercase">{bt(lang, 'total')}</span>
              <span className="font-heading font-black text-lg text-[#EE5A01]">AED {getPrice().toLocaleString()}</span>
            </div>
          </div>
          <button data-testid="book-another-btn" onClick={onReset} className="btn-primary">{bt(lang, 'bookAnotherRide')}</button>
        </div>
      </div>
    </div>
  );
}
